import "../components/Tab";
import "../components/FilterModal";

import { cleanupQueryParamsFromLinks } from "../utils";
document.addEventListener('DOMContentLoaded', () => {
  cleanupQueryParamsFromLinks(['#js-global-nav', '.f-footer', 'main']);
});